<template>
    <b-form @submit.prevent="save()">
        <input
            type="submit"
            class="d-none"
        >

        <h4 class="mb-4">
            {{ $t('users.edit.company.nav') }}
        </h4>

        <b-row align-v="center">
            <b-col class="d-flex align-items-center">
                <b-form-group
                    class="mb-0"
                    :invalid-feedback="company.errors.image"
                    :state="!company.errors.image"
                    :disabled="!editable"
                >
                    <ow-image-select v-model="company.image" />
                </b-form-group>

                <label class="col-form-label ml-4">
                    {{ $t('groups.fields.logo') }}
                </label>
            </b-col>

            <b-col>
                <b-form-group
                    class="mb-0"
                    :label="$t('groups.fields.name')"
                    :invalid-feedback="company.errors.name"
                    :state="!company.errors.name"
                    :disabled="!editable"
                >
                    <b-input v-model="company.name" />
                </b-form-group>
            </b-col>
        </b-row>
    </b-form>
</template>

<script>
import {Company} from '@/models/Company';
import OwImageSelect from '@/components/common/form/OwImageSelect';

export default {
    name: 'CompanyForm',
    components: {OwImageSelect},
    props: {
        company: {
            type: Company,
            required: true,
        },
        editable: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    methods: {
        async save() {
            if (!this.editable) {
                return;
            }

            await this.company.save();
        },
    },
};
</script>
